import { Component, HostListener, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent, MatTabGroup, MatTab } from '@angular/material/tabs';
import { Observable, Subject, combineLatest, takeUntil } from 'rxjs';
import { CamService } from 'src/app/services/camService/cam.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/apiService/api.service';
import { DatePipe, NgIf, NgStyle, NgFor } from '@angular/common';
import { ContentService } from '../../services/content.service';
import { LocalSessionStorage } from 'src/app/models/interface/FlightSearch/CommanModel.interface';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { AutoBlurSelectDirective } from '../../../../shared/directive/auto-select-blur.directive';
import { MatOption, MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
@Component({
    selector: 'app-preferences-form',
    templateUrl: './preferences-form.component.html',
    styleUrls: ['./preferences-form.component.scss'],
    imports: [ReactiveFormsModule, NgIf, MatIcon, MatFormField, MatLabel, MatSuffix, NgStyle, MatSelect, AutoBlurSelectDirective, NgFor, MatOption, MatInput, MatAutocompleteTrigger, MatAutocomplete, MatButton, MatProgressSpinner]
})

export class PreferencesFormComponent implements OnInit, OnDestroy {
  displayedColumns1: string[] = ['SrNo', 'AirLineName', 'LoyaltyExpiryDate', 'LoyaltyNumber', 'Primary', 'actions'];
  preferenceinfoForm: FormGroup;
  dataSource1: MatTableDataSource<any> = new MatTableDataSource();
  IsInternationalFlightRule: boolean = false;
  MealsList: any[] = [];
  filteredMeals: any[] = [];
  mealControl = new FormControl();
  selectedMeal!: string;
  userPreferences: any;
  selectedSeatPreference: string = '';
  selectedSeatPreference1: string = '';
  selectedExpiryDate: Date | string | null = new Date();
  selectedStopPreference: string = '';
  selectedMaxLayover: string = '';
  selectedClassPreference: string = '';
  filteredAirlines!: Observable<any[]>;
  selectedAirline!: string;
  ssrNameList: any[] = [];
  preferenceControl = new FormControl('');
  filteredPreferences!: Observable<any[]>;
  selectedPreferences: string[] = [];
  airlineListLoyalty: any[] = [];
  filteredAirlinesLoyalty!: Observable<any[]>;
  airlineControlLoyalty = new FormControl();
  selectedAirlineLoyalty!: string;
  userId: string = '';
  guid: string = '';
  userData: any[] = [];
  isInternationalFlight: string = '';
  isChildVisible: { [key: string]: boolean } = {
    isVisibleCalendar: false,
    isEditVisibleCalendar: false,
  };
  initialFormValue: any;
  minDate: any = { year: null, month: null, date: null }
  maxDate: any = { year: null, month: null, date: null }
  formattedPPExpiryDate: string = '';
  commonObjPipes: any = {
    mealPref: { pipe: [], all: [] },
    seatingPref: { pipe: [], all: [] },
    shorthaulSeatingPref: { pipe: [], all: [] },
    prefStopover: { pipe: [], all: [] },
    prefMaxLayout: { pipe: [], all: [] },
    prefClass: { pipe: [], all: [] },
    airlineCode: { pipe: [], all: [] },
    otherPref: { pipe: [], all: [] },
  }
  departureDate: any;
  editpersonal: boolean = false;
  Loader: any = {
    isSpinner: false,
    isEditableClicked: false
  }
  EditLoyaltyProgram: FormGroup;
  commonObj: any = {
    loyalty: {},
    loyaltyIndex: null,
    removeLoyalties: []
  }
  hasFormData: boolean = false;
  noDataPersonalInfo!: boolean
  companySettingDetails: any = {};
  // isProfileViewRestricted: boolean = false;
  private readonly destroy$ = new Subject<void>();
  content: any;

  // Custom validator for loyaltyNumber: if value exists, must be exactly 10 characters
  private loyaltyNumberValidator(control: AbstractControl) {
    const rawValue = control.value;
    const value = rawValue == null ? '' : String(rawValue).trim();
    // If this loyalty row is not active, don't block saving based on its loyalty number.
    const parentGroup = control.parent as FormGroup | null;
    const isActive = parentGroup?.get('isActive')?.value;
    if (isActive === false) {
      return null;
    }
    if (!value) {
      return null; // No validation error if empty
    }
    if (value.length !== 10) {
      return { invalidLength: true }; // Error if length is not 10
    }
    return null; // Valid
  }

  constructor(private readonly fb: FormBuilder, private readonly _CamApiService: CamService, public _CommonService: CommonService, private readonly _ToastrApiService: ToastrApiService, private readonly _ApiService: ApiService, private readonly _MatDialog: MatDialog, private readonly datePipe: DatePipe, private readonly contentService: ContentService, private readonly dictionaryContentService: DisctionaryContent, private readonly travelerManagement: TravelerManagement) {

    this.preferenceinfoForm = this.fb.group({
      loyaltyPrograms: this.fb.array([]),
      saUserId: this._ApiService.getSession('userId'),
      seatingPref: [""],
      mealPref: [""],
      otherPref: "",
      prefStopover: [""],
      prefMaxLayout: [""],
      prefClass: [""],
      shorthaulSeatingPref: [""],
      isInternationalFlight: true,
      serviceType: "F",
      prefLoyaltyPrograms: this.fb.group({
        saUserId: this._ApiService.getSession('userId'),
        airlineCode: "Saudia Airlines SV",
        loyaltyNumber: ["", this.loyaltyNumberValidator],
        loyaltyExpiryDate: null,
        isInternationalFlight: true
      })
    });

    this.EditLoyaltyProgram = this.fb.group({
      airlineCode: [""],
      loyaltyNumber: ["", this.loyaltyNumberValidator],
      loyaltyExpiryDate: [null],
    })
  }
  ngOnInit(): void {
    combineLatest({
      content: this.contentService.content$, dictionary: this.dictionaryContentService.content$
    }).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = {
        ...res.content,
        dictionary: res.dictionary
      }
    });
    this.isInternationalFlight = '1';
    this.userId = sessionStorage.getItem('userId') || '';
    this.guid = sessionStorage.getItem('guid') || '';
    const stored = localStorage.getItem(LocalSessionStorage.COMPANY_SETTINGS) ?? sessionStorage.getItem(LocalSessionStorage.COMPANY_SETTINGS);
    this.companySettingDetails = stored && stored !== 'undefined' ? JSON.parse(stored) : {};
    // const travelerGUID = localStorage.getItem('travelerGUID')?.toLowerCase();
    // const userGuid = localStorage.getItem('userGuid')?.toLowerCase();
    // this.isProfileViewRestricted = this.companySettingDetails?.restrictAmendmentInTravelerProfile && (travelerGUID !== userGuid);
    // if (this.isProfileViewRestricted) {
    //   this.preferenceinfoForm.disable();
    // }

    this.getPrefrenceData();
    this.bindPrefLoyaltyNumberToFirstProgram();
    this.editpersonal = false;
    this.onDepartureDateChange(this.selectedExpiryDate);
    this.noDataPersonalInfo = this._CommonService.getData('camSidebar')

    console.log(this.preferenceinfoForm, "preferenceinfoForm");


  }


  getPrefrenceData() {
    if (this.userId && this.guid) {
      this._CamApiService.GetPreferenceDetails(this._ApiService.getSession('userId'), this.guid, this.isInternationalFlight).then((response: any) => {
        console.log(response, "response get preference");

        if (response?.status === 'Success') {
          this.userData = response.data;
          this.bindLists('mealPref', response.data[0].MealsList);
          this.bindLists('seatingPref', this._CommonService.seatPreferences);
          this.bindLists('shorthaulSeatingPref', this._CommonService.seatPreferences);
          this.bindLists('prefStopover', this._CommonService.stopPreferences);
          this.bindLists('prefMaxLayout', this._CommonService.maxLayoverOptions);
          this.bindLists('prefClass', this._CommonService.classPreferences);
          this.bindLists('airlineCode', response.data[0].AirlineList);
          this.bindLists('otherPref', response.data[0].OtherPreferenceList);
          this.ssrNameList = response.data[0].SsrNameList;
          if (response.data[0].UserPreference?.[0]?.Status === 'Success') {
            response.data[0].UserPreference.prefLoyaltyPrograms = response.data[0].UsersPrefLoyaltyPrograms
            this.userPreferences = response.data[0].UserPreference;
            this.IsInternationalFlightRule = response.data[0].UserPreference[0].IsInternationalFlight;
            this.dataSource1 = new MatTableDataSource(response.data[0].UserPreference[0].pref_loyalityPrograms);
            // this.processData(response.data[0].UserPreference[0].pref_loyalityPrograms)
            this.setFormValues();
          }
        }
      }).catch((error: any) => { console.error('Error fetching Pax Titles:', error); });
    } else {
      this.editpersonal = false;
      this.Loader.isEditableClicked = false;
    }
  }

  isFormChanged(): boolean {
    const currentValue = JSON.stringify(this.preferenceinfoForm.value);
    return currentValue !== this.initialFormValue;
  }



  createLoyaltyProgram(data: any): FormGroup {
    return this.fb.group({
      isPrimary: data?.isPrimary ?? false,
      saUserId: [this._ApiService.getSession('userId')],
      airlineCode: ['Saudia Airlines SV'],
      loyaltyNumber: [data.loyaltyNumber ?? '', this.loyaltyNumberValidator],
      loyaltyExpiryDate: (data.loyaltyExpiryDate?.match(/\//)?.length ?? 0) > 0 ? this._CommonService.postFormatDate(data.loyaltyExpiryDate) : data.loyaltyExpiryDate ?? null,
      isInternationalFlight: data.isInternationalFlight,
      LoyaltyProgramID: data?.LoyaltyProgramID ?? 0,
      isActive: data?.isActive ?? data?.IsActive ?? true,
    })
  }

  createLoyaltyPush() {
    const loyality = this.preferenceinfoForm.get('prefLoyaltyPrograms') as FormGroup;
    if (loyality.invalid) {
      return;
    }

    // Get the current form values
    const currentValues = this.preferenceinfoForm.get('prefLoyaltyPrograms')?.value;

    // Push the new loyalty program
    (this.preferenceinfoForm.get('loyaltyPrograms') as FormArray)
      .push(this.createLoyaltyProgram(currentValues));

    // Reset the form with the correct isInternationalFlight value
    this.preferenceinfoForm.get('prefLoyaltyPrograms')?.reset({
      saUserId: this._ApiService.getSession('userId'),
      airlineCode: "Saudia Airlines SV",
      loyaltyNumber: "",
      loyaltyExpiryDate: null,
      isInternationalFlight: true
    });

    // Mark the form as dirty since we made changes
    this.preferenceinfoForm.markAsDirty();
  }

  removeLoyalty(index: number) {
    (this.preferenceinfoForm.get('loyaltyPrograms') as FormArray).at(index).get("isActive")?.setValue(false);
    // Mark the form group as dirty
    this.preferenceinfoForm.get('prefLoyaltyPrograms')?.markAsDirty();
    // Re-run validation for the loyaltyNumber so inactive rows don't keep the form invalid.
    const loyaltyArray = this.preferenceinfoForm.get('loyaltyPrograms') as FormArray | null;
    const row = loyaltyArray?.at(index) as FormGroup | undefined;
    row?.get('loyaltyNumber')?.updateValueAndValidity({ emitEvent: false });
  }
  radioChecked(data: any, preRefI: number) {
    this.preferenceinfoForm.get('loyaltyPrograms')?.value.forEach(($loyal: any, $loyalIndex: number) => {
      if ($loyalIndex == preRefI) {
        (this.preferenceinfoForm.get('loyaltyPrograms') as FormArray).at($loyalIndex).get("isPrimary")?.setValue(true);
      } else {
        (this.preferenceinfoForm.get('loyaltyPrograms') as FormArray).at($loyalIndex).get("isPrimary")?.setValue(false);
      }
    });
    this.preferenceinfoForm.get('prefLoyaltyPrograms')?.markAsDirty();
  }
  bindLists(key: string, lists: any[]) {
    this.commonObjPipes[key].pipe = lists;
    this.commonObjPipes[key].all = lists;
  }

  private getMealCodeByDescription(description: string): string {
    const meal = this.commonObjPipes.mealPref.all.find((m: any) => m.MealDescription === description);
    return meal?.MealCode ?? description;
  }

  private getMealDescriptionByCode(code: string): string {
    const meal = this.commonObjPipes.mealPref.all.find((m: any) => m.MealCode === code);
    return meal?.MealDescription ?? code;
  }

  private getSSRCodeByName(name: string): string {
    const option = this.commonObjPipes.otherPref.all.find((o: any) => o.SSRName === name);
    return option?.SSRCode ?? name;
  }

  private getSSRNameByCode(code: string): string {
    const option = this.commonObjPipes.otherPref.all.find((o: any) => o.SSRCode === code);
    return option?.SSRName ?? code;
  }

  private bindPrefLoyaltyNumberToFirstProgram() {
    const prefCtrl = this.preferenceinfoForm.get(`prefLoyaltyPrograms.loyaltyNumber`) as FormControl | null;
    const loyaltyArray = this.preferenceinfoForm.get(`loyaltyPrograms`) as FormArray | null;
    if (!prefCtrl || !loyaltyArray) {
      return;
    }

    prefCtrl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((val) => {
      if (!loyaltyArray.length) {
        return;
      }
      const firstRow = loyaltyArray.at(0) as FormGroup;
      const loyaltyNumberCtrl = firstRow?.get('loyaltyNumber') as FormControl | null;
      if (!loyaltyNumberCtrl) {
        return;
      }

      // Sync display loyaltyNumber -> loyaltyPrograms[0].loyaltyNumber
      if (loyaltyNumberCtrl.value !== val) {
        loyaltyNumberCtrl.patchValue(val, { emitEvent: false });
        loyaltyNumberCtrl.updateValueAndValidity({ emitEvent: false });
      }
    });
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const clickedElement = event.target as HTMLElement;

    // Check if the click is outside of `.calendar-wrapper` and `.control-wrapper`
    if (!clickedElement.closest('.custom-parent-calendar')) {
      // Close the calendar
      this.isChildVisible['isVisibleCalendar'] = false;
      this.isChildVisible['isEditVisibleCalendar'] = false;
    }
  }
  _filterCommon(type: string, value: string, key: string): any[] {
    const filterValue = value.toLowerCase();
    return this.commonObjPipes[type].all.filter((meal: any) => meal[key].toLowerCase().includes(filterValue));
  }
  filterControls(type: string, event: any, key: string) {
    event = event?.target?.value ?? event.value
    this.commonObjPipes[type].pipe = this._filterCommon(type, event || '', key);
  }
  selectPreference(preference: any) {
    if (preference) {
      if (!this.selectedPreferences.includes(preference)) {
        this.selectedPreferences.push(preference)
      }
      this.preferenceinfoForm.get('otherPref')?.setValue('')
    }
  }

  removePreference(preferenceName: string) {
    this.travelerManagement.traveler_detail_click('Remove');
    this.selectedPreferences = this.selectedPreferences.filter(
      item => item !== preferenceName
    );

    this.preferenceinfoForm.patchValue({
      otherPref: this.selectedPreferences
    });
  }

  showAllPreferences() {
    this.preferenceControl.setValue('');
  }
  selectAirlineloyalty(airlineName: string) {
    const selected = this.airlineListLoyalty.find(airline => airline.airlinename === airlineName);
    if (selected) {
      this.selectedAirlineLoyalty = selected.airlinecode;
      this.airlineControlLoyalty.setValue(selected.airlinename);
    }
  }

  Editpersonal() {
    // GTM Event Call
    this.travelerManagement.traveler_detail_click('Edit');
    this.editpersonal = true;
    this.Loader.isEditableClicked = false;
  }
  setFormValues() {
    const userPreference = this.userPreferences;
    if (Array.isArray(userPreference) && userPreference.length > 0) {
      const clearFormArray = (formArray: FormArray | null | undefined) => {
        if (!formArray) {
          return;
        }
        while (formArray.length) {
          formArray.removeAt(0);
        }
      };

      clearFormArray(this.preferenceinfoForm.get('loyaltyPrograms') as FormArray);
      this.selectedPreferences = [];

      const userPref = userPreference[0];
      const loyaltyPrograms = (typeof userPref?.other_pref === 'string') ? userPref.other_pref.split(',') : [];
      const filteredPrefs = loyaltyPrograms.filter((s: string) => (s ?? '').trim().length > 0);
      
      this.selectedPreferences = filteredPrefs.length > 0
        ? filteredPrefs.map((code: string) => this.getSSRNameByCode(code.trim()))
        : [];
      
      this.preferenceinfoForm.patchValue({
        saUserId: userPref?.SA_User_ID ?? "",
        seatingPref: userPref?.seating_pref ?? "",
        mealPref: this.getMealDescriptionByCode(userPref?.meal_pref ?? ""),
        prefStopover: userPref?.pref_stopover ?? "",
        prefMaxLayout: userPref?.pref_max_layout ?? "",
        prefClass: userPref?.pref_class ?? "",
        shorthaulSeatingPref: userPref?.shorthaul_seating_pref ?? "",
        isInternationalFlight: true,
        serviceType: userPref?.ServiceType ?? "F",
        otherPref: (typeof userPref?.other_pref === 'string') ? userPref.other_pref.split(',') : []
      });

      this.userData[0].UsersPrefLoyaltyPrograms.forEach(($pref: any) => {
        (this.preferenceinfoForm.get('loyaltyPrograms') as FormArray).push(
          this.createLoyaltyProgram({
            isPrimary: $pref.Is_Primary,
            saUserId: this._ApiService.getSession('userId'),
            airlineCode: $pref.AirlineCode,
            loyaltyNumber: $pref.LoyaltyNumber,
            loyaltyExpiryDate: $pref.LoyaltyExpiryDate,
            isInternationalFlight: true,
            LoyaltyProgramID: $pref?.LoyaltyProgramID ?? 0,
            isActive: $pref?.isActive ?? true,
          })
        )
      })

      const loyaltyArray = this.preferenceinfoForm.get('loyaltyPrograms') as FormArray | null;
      const prefLoyaltyGroup = this.preferenceinfoForm.get('prefLoyaltyPrograms') as FormGroup | null;
      if (loyaltyArray?.length && prefLoyaltyGroup) {
        const firstLoyalty = loyaltyArray.at(0).value;
        prefLoyaltyGroup.patchValue({
          loyaltyNumber: firstLoyalty?.loyaltyNumber ?? '',
        });
        prefLoyaltyGroup.get('loyaltyNumber')?.updateValueAndValidity({ emitEvent: false });
      }
    }
    this.preferenceinfoForm.updateValueAndValidity();
    this.hasFormData = this._CommonService.hasAnyValue(this.preferenceinfoForm.value)
    if (this.hasFormData) {
      this.Loader.isEditableClicked = true;
    } else {
      this.Loader.isEditableClicked = false;
    }
    this.initialFormValue = JSON.stringify(this.preferenceinfoForm.value);
  }

  savePreferences() {
    // GTM Event - Save Preferences Click
    this.travelerManagement.traveler_detail_click('Save');
    this.Loader.isSpinner = true;
    
    this.preferenceinfoForm.markAllAsTouched();
    if (this.preferenceinfoForm.invalid) {
      this.Loader.isSpinner = false;
      return;
    }
    
    let copy = structuredClone(this.preferenceinfoForm.value);
    const prefLoyaltyGroup = this.preferenceinfoForm.get('prefLoyaltyPrograms') as FormGroup | null;
    const loyaltyProgramsArray = this.preferenceinfoForm.get('loyaltyPrograms') as FormArray | null;

    if (prefLoyaltyGroup && loyaltyProgramsArray?.length) {
      const prefLoyalty = prefLoyaltyGroup.value;
      const firstLoyaltyControl = loyaltyProgramsArray.at(0) as FormGroup;
      if (firstLoyaltyControl && prefLoyalty?.loyaltyNumber !== undefined) {
        firstLoyaltyControl.patchValue(
          {
            loyaltyNumber: prefLoyalty.loyaltyNumber
          },
          { emitEvent: false }
        );
        firstLoyaltyControl.get('loyaltyNumber')?.updateValueAndValidity({ emitEvent: false });
      }
    }

    const loyaltyProgramsPayload: any[] = [];

    if (loyaltyProgramsArray?.length) {
      loyaltyProgramsArray.value.forEach((item: any) => {
        if (!item) { return; }
        loyaltyProgramsPayload.push({
          saUserId: item.saUserId ?? this._ApiService.getSession('userId'),
          airlineCode: item.airlineCode ?? 'Saudia Airlines SV',
          loyaltyProgramID: item.LoyaltyProgramID ?? 0,
          loyaltyNumber: item.loyaltyNumber,
          isInternationalFlight: true,
          isPrimary: item.isPrimary ?? true,
          isActive: item.isActive ?? true
        });
      });
    }

    if (!loyaltyProgramsPayload.length && prefLoyaltyGroup) {
      const prefLoyalty = prefLoyaltyGroup.value;
      if (prefLoyalty?.loyaltyNumber) {
        loyaltyProgramsPayload.push({
          saUserId: this._ApiService.getSession('userId'),
          airlineCode: 'Saudia Airlines SV',
          loyaltyProgramID: 0,
          loyaltyNumber: prefLoyalty.loyaltyNumber,
          isInternationalFlight: true,
          isPrimary: true,
          isActive: true
        });
      }
    }

    // Always send loyaltyPrograms as a single object (0th index of array)
    copy.loyaltyPrograms = loyaltyProgramsPayload.length ? loyaltyProgramsPayload[0] : null;
    delete copy.prefLoyaltyPrograms;
    if (copy.mealPref) {
      copy.mealPref = this.getMealCodeByDescription(copy.mealPref);
    }
    copy.otherPref = this.selectedPreferences.map((name) => this.getSSRCodeByName(name)).join(',');

    const contactId = localStorage.getItem('contactID');
    const accountId = localStorage.getItem('additionalRefNo');

    copy.accountId = accountId;
    copy.contactId = contactId;

    this._CamApiService.UpdatePreferenceDetails(copy).then(($res: any) => {
      //setTimeout(() => {
      this.Loader.isSpinner = false;
      this.Loader.isEditableClicked = true;
      this.editpersonal = false;
      this.preferenceinfoForm.markAsPristine();
      this._ToastrApiService.show('success', $res.message);
      this.travelerManagement.loyalty_update_status('Success', 'NA');
      // setTimeout(() => {
      //   globalThis.location.reload();
      // }, 5000);
    }).catch((error: any) => {
      this.Loader.isSpinner = false;
      console.log('error ', error);
      this._ToastrApiService.show('error', this.getErrorMessage(error?.error?.message));
      this.travelerManagement.loyalty_update_status('Failure', error?.error?.message);
    });
  }
  getErrorMessage(response: any): string {
    let data = response;

    if (!data) {
      return '';
    }

   // Agar message JSON string hai
   if (typeof data === 'string') {
     try {
       data = JSON.parse(data);
     } catch {
       // Normal string hai, JSON nahi
       return data;
     }
   }
    console.log('decoded message', data);
   return data?.error?.details?.[0]?.message
     || data?.error?.message
     || '';
 }

  showComponent(componentKey: string): void {
    this.isChildVisible[componentKey] = true;
    for (const key in this.isChildVisible) {
      if (key !== componentKey) {
        this.isChildVisible[key] = false;
      }
    }
    this.selectedExpiryDate = this.preferenceinfoForm?.get('prefLoyaltyPrograms')?.get('loyaltyExpiryDate')?.value;
  }
  validateExpiryDate(): boolean {

    const expiryControl = this.preferenceinfoForm.get('loyaltyExpiryDate') as FormControl;

    if (!expiryControl || expiryControl.invalid) {
      return false;
    }

    const expiryValue = expiryControl.value;
    if (!expiryValue) {
      expiryControl.setErrors({ required: true });
      return false;
    }

    let expiryString: string;

    if (expiryValue instanceof Date) {
      const day = expiryValue.getDate().toString().padStart(2, '0');
      const month = (expiryValue.getMonth() + 1).toString().padStart(2, '0');
      const year = expiryValue.getFullYear();
      expiryString = `${day}/${month}/${year}`;
    } else {
      expiryString = expiryValue;
    }

    const expiryFormatRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!expiryFormatRegex.test(expiryString)) {
      expiryControl.setErrors({ invalidFormat: true });
      return false;
    }

    const [day, month, year] = expiryString.split('/').map(Number);
    const expiryDate = new Date(year, month - 1, day);

    if (day === 0 || month === 0 || year === 0) {
      expiryControl.setErrors({ invalidFormat: true });
      return false;
    }


    if (month > 12) {
      expiryControl.setErrors({ invalidFormat: true });
      return false;
    }

    const lastDayOfMonth = new Date(year, month, 0).getDate();
    if (day > lastDayOfMonth) {
      expiryControl.setErrors({ invalidFormat: true });
      return false;
    }
    // Validate against minDate and maxDate
    const datePlusSixMonths = new Date(this.minDate.year, this.minDate.month, this.minDate.date);
    // Add 6 months to minDate
    const minDate = new Date(datePlusSixMonths);
    minDate.setMonth(minDate.getMonth() + 6);
    const maxDate = new Date(this.maxDate.year, this.maxDate.month, this.maxDate.date);
    if (expiryDate < minDate || expiryDate > maxDate) {
      expiryControl.setErrors({ invalidExpiryDate: true });
      return false;
    }
    expiryControl.setErrors(null);
    return true;
  }
  onDateSelected(event: any, isEditLoyalty: boolean = false): void {
    if (event.type === 'dob') {
      if (!event.date || event.date.toDateString() === new Date(0).toDateString()) {
        return;
      }
      const formattedDate = this._CommonService.getFormattedDate(event.date);
      this.selectedExpiryDate = event.date;
      this.formattedPPExpiryDate = formattedDate || '';
      if (isEditLoyalty) {
        this.EditLoyaltyProgram?.get('loyaltyExpiryDate')?.setValue(this.formattedPPExpiryDate);
        this.isChildVisible['isEditVisibleCalendar'] = false;
      } else {
        this.preferenceinfoForm?.get('prefLoyaltyPrograms')?.get('loyaltyExpiryDate')?.setValue(this.formattedPPExpiryDate);
        this.isChildVisible['isVisibleCalendar'] = false;
      }
    }
  }

  onDepartureDateChange(departureDate: Date | string | null): void {
    this.departureDate = departureDate;
    this.setMinDateRange();
    this.setMaxDateRange();
  }

  setMinDateRange() {
    let departureDate = new Date(this.departureDate);
    let year = departureDate.getFullYear();
    let month = departureDate.getMonth();
    let date = departureDate.getDate();
    this.minDate = { year, month, date };
  }

  setMaxDateRange() {
    let minDate = new Date(this.minDate.year, this.minDate.month, this.minDate.date);
    minDate.setFullYear(minDate.getFullYear() + 47);
    let year = minDate.getFullYear();
    let month = minDate.getMonth();
    let date = minDate.getDate();
    this.maxDate = { year, month, date };
  }
  Cancel() {
    // GTM Event Call
    this.travelerManagement.traveler_detail_click('Cancel');
    this.editpersonal = false;
    this.Loader.isEditableClicked = true;
    this.setFormValues();
    // Remove validation UI state (touched/dirty + recompute validity for server values).
    this.preferenceinfoForm.markAsPristine();
    this.preferenceinfoForm.markAsUntouched();
    this.preferenceinfoForm.updateValueAndValidity({ emitEvent: false });
    this.initialFormValue = JSON.stringify(this.preferenceinfoForm.value);
  }
  editLoyaltyProgram(template: TemplateRef<any>, loyalty: any, loyaltyIndex: number) {
    this.commonObj.loyalty = loyalty;
    this.commonObj.loyaltyIndex = loyaltyIndex;
    this._MatDialog.open(template, { panelClass: "seatSelectorPopup", autoFocus: false, disableClose: true });
    loyalty.loyaltyExpiryDate = this.datePipe.transform(loyalty.loyaltyExpiryDate, 'dd/MM/yyyy');
    this.EditLoyaltyProgram.patchValue(loyalty);
  }
  CloseDialog(isClose: boolean): void {
    if (!isClose) {
      this.EditLoyaltyProgram.value.loyaltyExpiryDate = new Date(this._CommonService.postFormatDate(this.EditLoyaltyProgram.value.loyaltyExpiryDate)).toISOString();
      (this.preferenceinfoForm?.get('loyaltyPrograms') as FormArray)?.at(this.commonObj.loyaltyIndex)?.patchValue(this.EditLoyaltyProgram.value);

      this.preferenceinfoForm.markAsDirty();
    }
    this._MatDialog.closeAll();
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
